import { Link } from "react-router-dom";
import type { PostItem } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

interface PostCardProps {
  post: PostItem;
}

export default function PostCard({ post }: PostCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/article/${post.id}`} className="block relative w-full h-48 overflow-hidden">
        <img
          src={post.cover}
          alt={`${post.title}相关配图`}
          title={`${post.title} - 吃瓜看料`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2 py-1 text-xs font-semibold text-background-50 whitespace-nowrap">
          {post.categoryName}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/article/${post.id}`}>
          <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 line-clamp-2">
            {post.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {post.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between gap-3 pt-3 border-t border-background-200/70">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-user-3-line" aria-hidden="true"></i>
            <span className="whitespace-nowrap">{post.author}</span>
            <span className="text-foreground-300">·</span>
            <span className="whitespace-nowrap">{post.publishedAt}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
              {formatCount(post.heat)}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-chat-3-line" aria-hidden="true"></i>
              {post.comments}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}